import { get } from '../../../../redux/api';
import { useMutation } from '../../../../ReactQuery';
import { useAddToast } from '../../../../contexts/ToastContext';
import type { Task } from '../../../../types';
import { useAddJobToNotificationQueue } from '../../../JobNotificationHub';

function generate(url: string) {
  return get<Task>(url);
}

/**
 * Custom hook to generate list of Issues as a CSV file
 */
export default function useGenerateCSVIssues() {
  const addToast = useAddToast();
  const addJob = useAddJobToNotificationQueue();
  return useMutation({
    mutationFn: generate,
    onSuccess: (response) => {
      addToast({
        type: 'success',
        content: 'Your report is being generated and will be emailed to you.',
      });
      if (response.ok && response.data?.jobToken) {
        addJob(response.data.jobToken, response.data.task);
      }
      return response;
    },
    onError: () => {
      addToast({
        type: 'error',
        content: 'Something went wrong while generating CSV file for issues. Please try again.',
      });
    },
  });
}
